import { useEffect } from 'react'

// Update allJobsLoaded when filteredJobs changes
export function useAllJobsLoadedEffect(
  filteredJobsLength: number,
  displayedJobsCount: number,
  setAllJobsLoaded: React.Dispatch<React.SetStateAction<boolean>>
) {
  useEffect(() => {
    if (filteredJobsLength <= displayedJobsCount) {
      setAllJobsLoaded(true)
    } else {
      setAllJobsLoaded(false)
    }
  }, [filteredJobsLength, displayedJobsCount, setAllJobsLoaded])
}

// Intersection Observer для lazy loading (подгрузка при 70% прокрутки)
export function useLazyLoadingEffect(
  allJobsLoaded: boolean,
  isLoadingMore: boolean,
  filteredJobsLength: number,
  setDisplayedJobsCount: React.Dispatch<React.SetStateAction<number>>,
  setAllJobsLoaded: React.Dispatch<React.SetStateAction<boolean>>,
  setIsLoadingMore: React.Dispatch<React.SetStateAction<boolean>>,
  loadMoreTriggerRef: React.RefObject<HTMLDivElement>
) {
  useEffect(() => {
    if (allJobsLoaded || isLoadingMore) return

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0]
        // Когда trigger элемент виден на 30% (т.е. прокручено 70%), загружаем следующую страницу
        if (entry.isIntersecting && entry.intersectionRatio >= 0.3) {
          setIsLoadingMore(true)
          // Загружаем следующую порцию (20 элементов)
          setDisplayedJobsCount((prev) => {
            const newCount = prev + 20
            const totalFilteredJobs = filteredJobsLength
            if (newCount >= totalFilteredJobs) {
              setAllJobsLoaded(true)
              return totalFilteredJobs
            }
            return newCount
          })
          // Небольшая задержка для плавности
          setTimeout(() => {
            setIsLoadingMore(false)
          }, 300)
        }
      },
      {
        threshold: [0, 0.3, 0.5, 1.0], // Срабатывает при 30% видимости
        rootMargin: '0px',
      }
    )

    if (loadMoreTriggerRef.current) {
      observer.observe(loadMoreTriggerRef.current)
    }

    return () => {
      if (loadMoreTriggerRef.current) {
        observer.unobserve(loadMoreTriggerRef.current)
      }
    }
  }, [allJobsLoaded, isLoadingMore, filteredJobsLength, setDisplayedJobsCount, setAllJobsLoaded, setIsLoadingMore, loadMoreTriggerRef])
}
